"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrganizationMemberInvitationSummaryResult = void 0;
const class_validator_1 = require("class-validator");
const base_get_result_dto_1 = require("../../../../common/dtos/base-get-result.dto");
/**
 * What an invitation link can tell you before you are anybody.
 *
 * The accept screen is reached from an email, by someone who may have no
 * account at all and certainly has no membership of the organization they are
 * being invited to. Every other read of an invitation goes through RLS, which
 * correctly returns nothing to that person — so the screen would have nothing
 * to render but the word "invitation" and a button, and could not say who
 * invited them or whether the link is still good.
 *
 * The invitation id in the URL is the credential here, exactly as it is for a
 * password reset link: a v4 UUID that only reaches someone who was sent the
 * email. This is why the response is deliberately narrow — the organization's
 * name, the role, who invited you, and whether the invitation is still open.
 * Nothing about the organization's members, its codes, or its billing.
 *
 * `invitedUserEmailAddress` is included because the screen must be able to say
 * "this invitation was sent to X" when the person following it is signed in as
 * somebody else — the single most likely way for an accept to fail. The address
 * is one the holder of the link was already sent mail at.
 */
class GetOrganizationMemberInvitationSummaryResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsString)()
], GetOrganizationMemberInvitationSummaryResult.prototype, "organizationName", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], GetOrganizationMemberInvitationSummaryResult.prototype, "organizationSlug", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], GetOrganizationMemberInvitationSummaryResult.prototype, "roleName", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], GetOrganizationMemberInvitationSummaryResult.prototype, "invitedByName", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], GetOrganizationMemberInvitationSummaryResult.prototype, "invitedUserEmailAddress", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)()
], GetOrganizationMemberInvitationSummaryResult.prototype, "open", void 0);
exports.GetOrganizationMemberInvitationSummaryResult = GetOrganizationMemberInvitationSummaryResult;
